
/**
 * Creates a slug of a specified string. 
 * @param {String} string 
 * 
 * @returns {String} the slug. 
 */
export const slugify = (str) => {
    {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
      
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
    
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes
    
        return str;
    }
}

// Keep the rear-row names explicit on cards and in their review dialogs.
export const formatPartPosition = position => {
    const label = String(position || '').trim();
    if (/^(second|third)\b/i.test(label)) {
        return label.replace(/^(second|third)(?:\s+row)?\b/i, '$1 Row');
    }

    return label.replace(/\s*row\b/i, '').trim();
};

// Preserve configured shipping copy while isolating the timeframe for emphasis.
export const splitStatusDetail = detail => {
    const text = String(detail || '');
    const match = text.match(/^(.*?)(\b\d+(?:\s*[-–—]\s*\d+)?\s+(?:business\s+)?(?:days?|weeks?)\b)(.*)$/i);
    return {
        detailBefore: match ? match[1] : text,
        detailHighlight: match ? match[2] : '',
        detailAfter: match ? match[3] : ''
    };
};
